import { useProductOptimization } from './ProductOptimizationContext';
import DiagnosisCard from './DiagnosisCard';
import { mockDiagnoses } from './_mock/mockDiagnoses';

const DiagnosisList = () => {
  const { diagnoses, isLoading } = useProductOptimization();

  if (isLoading) {
    return (
      <div className="py-[40px] text-center text-gr-500 Body5M14">불러오는 중...</div>
    );
  }

  // 리스트가 비어 있으면 예시 카드 (Figma 486:7996) 를 샘플로 표시
  const items = diagnoses.length > 0 ? diagnoses : mockDiagnoses;

  return (
    <div className="grid w-full grid-cols-1 gap-[12px] min-[1200px]:grid-cols-2">
      {items.map((d) => (
        <DiagnosisCard key={d.id} diagnosis={d} />
      ))}
    </div>
  );
};

export default DiagnosisList;
